module.exports = __webpack_public_path__ + "static/media/ShapeWhite.f05abbcd.svg";